export default __webpack_public_path__ + "static/media/femme-forte-white.4259f516.jpeg";